<div class="trusted-partner">
    <a *ngIf="partnerUrl" style="color: transparent; cursor: pointer; text-decoration: none;" href="{{partnerUrl}}"
        target="_blank">
        <img alt="{{partnerAlt}}" height="50" width="327" src="{{imgSrc}}">
    </a>
    <img *ngIf="!partnerUrl" alt="{{partnerAlt}}" height="50" width="327" src="{{imgSrc}}">
</div>